import template from 'lodash-es/template';
import uiIcon from '@shared/ui-icon';
import { T_ } from '@shared/translation';
import tableTemplate from './templates/tableTemplate.html';

export default function renderTable(
  parentId,
  data,
  showPostBtn,
  showBidBtn,
  onClickCallback,
) {
  // Takes JSON Data of projects/contests/local jobs and displays it
  const parent = document.getElementById(parentId);
  parent.innerHTML = template(tableTemplate)({
    T_,
    projects: data,
    uiIcon,
    showPostBtn,
    showBidBtn,
  });

  bindElement(onClickCallback, parent);
}

export function bindElement(onClickCallback, parent = document) {
  Array.from(parent.querySelectorAll('div[data-project-card="true"]')).forEach(
    el => {
      el.addEventListener('click', event => onClickCallback(event));
    },
  );
}
